import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=6fdf8a1b&"
import script from "./iframe.vue?vue&type=script&lang=js&"
export * from "./iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fdf8a1b')) {
      api.createRecord('6fdf8a1b', component.options)
    } else {
      api.reload('6fdf8a1b', component.options)
    }
    module.hot.accept("./iframe.vue?vue&type=template&id=6fdf8a1b&", function () {
      api.rerender('6fdf8a1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/youtubeVideo/iframe.vue"
export default component.exports